// extracted by mini-css-extract-plugin
export default {"middleContainer":"dpqWTZUujz7VBNDOcJ3n","icon":"uShYW7Ji1dQcL_99ouWT"};